import { useState } from "react";

export enum ClubTab {
  ALL,
  MY,
  MEMBER,
  CHAT,
}

export const useGameClub = () => {
  const [gameClubTab, setGameClubTab] = useState(ClubTab.ALL);

  const isGameClubTab = (tab: ClubTab) => gameClubTab === tab;

  return {
    gameClubTab,
    setGameClubTab,
    isGameClubTab,
  };
};
